import { SVGS } from '~/assets/assetsPath';

export const utilitiesApp = [
    { id: 1, title: 'Schedule', icon: SVGS.IconScheduleWhite },
    { id: 2, title: 'Process tracking', icon: SVGS.IconFollowingProcess },
    { id: 3, title: 'Evaluation', icon: SVGS.IconEvaluate },
    { id: 4, title: 'Beauty Tips', icon: SVGS.IconTipsBeauty },
    { id: 5, title: 'Shop', icon: SVGS.IconCartWhite },
    { id: 6, title: 'Soi da', icon: SVGS.IconSkinScreening },
    { id: 7, title: 'Contributor System', icon: SVGS.IconCTVWhite },
];
